import Super from 'client-portal/routes/-request/prescreener-billing-payment';

export default class WidgetPrescreenerBillingPayment extends Super {}
